export default "__VITE_ASSET__c721fd0c__"